module.exports = __webpack_public_path__ + "static/waterteether1-4c70b5bd5c35aa1ab2acd192aa254d07.jpeg";